import { axios } from '@/services/axios';

export const createVoicePolicy = (voicePolicyData) => {
    return axios.post('/VoicePolicy', voicePolicyData);
};
